import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grants-application-ext',
  templateUrl: './grants-application-ext.component.html',
  styleUrls: ['./grants-application-ext.component.scss']
})
export class GrantsApplicationExtComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
